import Config from '@src/config/Config';
import type { Configuration } from 'rollbar';

export const rollbarConfig: Configuration = {
  accessToken: Config.VITE_ROLLBAR_ACCESS_TOKEN,
  captureUncaught: true,
  captureUnhandledRejections: true,
  environment: Config.VITE_ROLLBAR_ENV,
  checkIgnore: (_isUncaught, args, _item): boolean => {
    for (const arg of args) {
      if (
        arg &&
        typeof arg === 'string' &&
        // Very specific errors from material ui
        (arg.includes('MissingRowIdError') ||
          arg.includes('Uncaught Error: No row with id') ||
          arg.includes('Error: No row with id') ||
          // Noisy exceptions thrown by the Chat Bubble element we load with a <script/> and have no control over.
          // Not so specific errors though, you may remove this if ignoring those errors
          // is making you more blind than the noise it used to create in the monitoring channel
          arg.includes('Cannot convert object to primitive value') ||
          arg.includes("can't convert Proxy to string") ||
          arg.includes('useResizeContainer'))
      ) {
        return true;
      }
    }
    return false;
  },
};
